// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://cpa-api.mileseducation.com/',
  cmaApiUrl: 'https://cma-api.mileseducation.com/',
  // apiUrl: 'https://cpa-api-dev.mileseducation.com/',
  // apiUrl: 'https://cpa-api-uat.mileseducation.com/',               //Dev Server
  // cmaApiUrl: 'https://cma-api.mileseducation.com/',
  // mentoringApiUrl: 'https://miles-lms-mentoring-live-dot-me-server-1.el.r.appspot.com/',

  // apiUrl: 'http://localhost:3801/',
  localUrlCma: 'http://localhost:3803/',
  // cmaApiUrl: 'https://default-cma-uat-dot-miles-server-2-331013.el.r.appspot.com/', // CMA
  // apiUrl: 'https://default-cpa-uat-dot-miles-server-2-331013.el.r.appspot.com/', // CPA
  authTokenKey: 'authtoken',
  PUSHER_API_KEY: '36b2aaddc3c40ad00f15',
  PUSHER_API_CLUSTER: 'ap2'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */










// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
